var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinimize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m497 38.33h-182.32c-6.49-22.13-26.97-38.33-51.18-38.33s-44.69 16.2-51.18 38.33h-107.8c-6.49-22.13-26.98-38.33-51.19-38.33-29.4 0-53.33 23.92-53.33 53.33 0 24.2 16.21 44.69 38.33 51.19v107.8c-22.12 6.49-38.33 26.98-38.33 51.18s16.21 44.69 38.33 51.18v182.32c0 8.28 6.72 15 15 15h443.67c8.452 0 15-6.878 15-15v-443.67c0-8.28-6.72-15-15-15zm-392.48 210.17c-5.1-17.37-18.82-31.09-36.19-36.18v-107.8c17.37-5.09 31.1-18.82 36.19-36.19h107.8c5.09 17.37 18.81 31.09 36.18 36.19v110.49c-15.68 5.38-28.11 17.81-33.49 33.49zm-36.19 66.18c17.37-5.09 31.09-18.81 36.19-36.18h109.1c5.68 23.59 26.97 41.17 52.28 41.17 29.64 0 53.77-24.13 53.77-53.78 0-25.3-17.59-46.59-41.17-52.27v-109.1c17.37-5.1 31.09-18.82 36.18-36.19h167.32v392.457l-84.697-84.697h45.595c8.284 0 15-6.716 15-15s-6.716-15-15-15c-88.162 0-83.146-.266-86.158.646-6.315 1.906-10.65 7.753-10.65 14.354v81.809c0 8.284 6.716 15 15 15s15-6.716 15-15v-45.596l84.697 84.697h-392.457z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.2899ba19.svg";
export { ForwardRef as ReactComponent };